import { render, staticRenderFns } from "./InformationModalButton.vue?vue&type=template&id=01811230&scoped=true"
import script from "./InformationModalButton.vue?vue&type=script&lang=js"
export * from "./InformationModalButton.vue?vue&type=script&lang=js"
import style0 from "./InformationModalButton.vue?vue&type=style&index=0&id=01811230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01811230",
  null
  
)

export default component.exports